module.exports = __webpack_public_path__ + "img/20200912_154837.ab1347d8.jpg";